import React, { Component } from 'react';
import styled, { css } from 'styled-components';

const StyledButton = styled.button`${
  (props) => {
    if (!props.styled) return '';

    const bgc = props.styled.backgroundColor;
    const fc = props.styled.color ? props.styled.color : 'white';
    const hbgc = props.styled.hover.backgroundColor;
    const { reverse } = props;
    const hfc = props.styled.hover.color;
    const hbs = props.styled.hover.boxShadow;
    
    if (reverse) {
      return css`
      && {
        border: 1px solid ${bgc};
        color: ${bgc};
        background-color: ${fc};
        &:hover, &:focus{
          background-color: ${bgc};
          color: ${fc};
          background-image: initial !important;
          box-shadow: ${hbs};
        }
      }`;
    }

    return css`
        && {
        border: 1px solid transparent;
        color: ${fc};
        background-color: ${bgc};
        &:hover{
          background-color: ${hbgc};  
          background-image: initial !important;
          box-shadow: ${hbs};
          color: ${hfc};
        }
      }`;
  }
}`;

export default class Button extends Component {
  onClick() {
    this.props.onClick();
  }

  render() {
    let fluid = !this.props.disableFluid ? 'fluid' : '';

    return (
      <StyledButton
        onClick={this.onClick.bind(this)}
        {...this.props}
        className={`${this.props.className} pure-button ${fluid}`}>
        {this.props.children}
      </StyledButton>
    );
  }
}
